import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import store from '../store'
import { ConnectionWSShared } from '@leapsight/styleguide'

Vue.use(VueRouter)

const routes: Array<RouteConfig> = [
  {
    path: '/live-tracking',
    name: 'liveTracking',
    component: () => import('../page/liveTracking.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/live-tracking/historical-tour',
    name: 'historicalTour',
    component: () => import('../page/historicalTour.vue'),
    meta: {
      requiresAuth: true
    },
    children: [
      {
        path: ':thing',
        name: 'historicalTour',
        meta: {
          requiresAuth: true
        },
        children: [
          {
            path: ':start&:end/:created?',
            name: 'historicalTour',
            meta: {
              requiresAuth: true
            }
          }
        ]
      }
    ]
  },
  {
    path: '/live-tracking/temperature-by-time',
    name: 'temperatureByTime',
    component: () => import('../page/temperatureByTime.vue'),
    meta: {
      requiresAuth: true
    },
    children: [
      {
        path: ':thing',
        name: 'temperatureByTime',
        meta: {
          requiresAuth: true
        },
        children: [
          {
            path: ':start&:end',
            name: 'temperatureByTime',
            meta: {
              requiresAuth: true
            }
          }
        ]
      }
    ]
  },
  {
    path: '/portal',
    name: 'launcher'
  },
  {
    path: '/fleet-management',
    name: 'fleet-management'
  },
  {
    path: '/portal/login',
    name: 'login'
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    //if the user is Logged we let them pass Next(), if not we redirect them to the login
    if (store.getters['authState/isLoggedIn']) {
      next()
    } else {
      next({ name: 'login' })
    }
  } else {
    //No se requiere auth
    next()
  }
})

router.beforeEach((to, from, next) => {
  if (from.name) {
    to.query.from = from.name
  }
  next()
})

window.addEventListener('beforeunload', event => {
  ConnectionWSShared.closeConnection()
})

export default router
